/* eslint-disable react/no-unused-prop-types */

import SVG from "components/SVG";
import { Info, type LucideIcon } from "lucide-react";
import { CSSProperties, ReactElement, forwardRef } from "react";
import { Tooltip, Whisper, WhisperProps } from "rsuite";

interface IPopupInfo extends Omit<WhisperProps, "children" | "speaker"> {
  label?: string;
  inputClassName?: string;
  inputStyle?: CSSProperties;
  className: string;
  children?: ReactElement;
  speaker?: ReactElement;
  icon?: LucideIcon;
  image?: string;
}

export const PopupInfo = forwardRef<HTMLDivElement, IPopupInfo>(
  (props: IPopupInfo, ref) => {
    const { label, style, className, trigger, placement, icon: IconComp = Info } = props;

    return (
      <div {...{ className, style, ref }}>
        <Whisper
          trigger={trigger}
          placement={placement}
          controlId={`control-id-${placement}`}
          speaker={
            <Tooltip>{label}</Tooltip>
          }
        >
          <div className="cursor-pointer hover:text-current-500">
            {props.image ? (
              <SVG src={props.image} alt={label} width={15} />
            ) : (
              <IconComp className="h-4 w-4 text-gray-500" />
            )}
          </div>
        </Whisper>
      </div>
    );
  }
);
